var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSnowman66(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.535,44.22l2.531-8.873l-3.846-1.098l-2.843,9.963l-7.131,4.023c-2.268-2.877-5.144-5.294-8.503-7.015 c3.723-3.271,6.089-8.053,6.089-13.387C67.833,18,59.833,10,50,10s-17.833,8-17.833,17.833c0,5.334,2.366,10.115,6.089,13.386 c-3.361,1.721-6.238,4.137-8.505,7.014l-7.128-4.021l-2.843-9.963l-3.846,1.098l2.531,8.873L10,46.833l1.18,3.822l9.514-2.938 l6.827,3.852c-2.131,3.786-3.33,8.111-3.33,12.622C24.19,78.422,35.769,90,50,90c14.231,0,25.81-11.578,25.81-25.81 c0-4.508-1.2-8.833-3.333-12.62l6.83-3.853l9.514,2.938L90,46.833L81.535,44.22z M50,71.515c-2.599,0-4.706-2.107-4.706-4.706 s2.107-4.706,4.706-4.706s4.706,2.107,4.706,4.706S52.599,71.515,50,71.515z M50,56.359c-2.599,0-4.706-2.107-4.706-4.706 c0-2.599,2.107-4.706,4.706-4.706s4.706,2.107,4.706,4.706C54.706,54.252,52.599,56.359,50,56.359z M50,37.129 c-2.557,0-4.945-1.393-6.232-3.636l2.601-1.494c0.766,1.334,2.123,2.13,3.631,2.13c1.508,0,2.865-0.796,3.631-2.13l2.602,1.494 C54.945,35.735,52.557,37.129,50,37.129z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnowman66);
export default __webpack_public_path__ + "static/media/snowman-66.e81a64de91469e7d8c2074aa0b6bda36.svg";
export { ForwardRef as ReactComponent };